import { render, staticRenderFns } from "./Item17.vue?vue&type=template&id=2f1cdc46&scoped=true&"
import script from "./Item17.vue?vue&type=script&lang=js&"
export * from "./Item17.vue?vue&type=script&lang=js&"
import style0 from "./Item17.vue?vue&type=style&index=0&id=2f1cdc46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1cdc46",
  null
  
)

export default component.exports